export enum QrCodeType {
    IN_LOCO = "IN_LOCO",
    DELIVERY_AND_TAKEAWAY = "DELIVERY_AND_TAKEAWAY"
}